import { render, staticRenderFns } from "./DetentionModal.vue?vue&type=template&id=22873add&"
import script from "./DetentionModal.vue?vue&type=script&lang=js&"
export * from "./DetentionModal.vue?vue&type=script&lang=js&"
import style0 from "./DetentionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports